import { Component, Inject, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation, OnDestroy, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { LayoutService } from 'src/app/layout/layout.service';
import { buttonTypes, ComponentTypes } from '../../constants/commonenums';
import { ButtonValue } from '../../dynamicform/models/common-models';
import { DynamicComponenReference } from '../../dynamicform/models/popup.interface';
import { GuestService } from '../../services/guest.service';
import { PopupService } from '../../services/popup.service';

@Component({
    selector: 'app-popup',
    templateUrl: './popup.component.html',
    styleUrls: ['./popup.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PopupComponent implements OnInit, OnDestroy, AfterViewInit {
  okayBtn: ButtonValue;
  cancelBtn: ButtonValue;
  @ViewChild('dynamicComponent', { read: ViewContainerRef }) dynamicComponent: ViewContainerRef;
  dialogTitle:string ='';
  actionSubscription: Subscription;
  constructor(public dialogRef: MatDialogRef<PopupComponent>, @Inject(MAT_DIALOG_DATA) public dialogData,
  public ps: PopupService, public ls:LayoutService, public gs:GuestService) { }
  componentName1: any;
  ngOnInit(): void {
    this.okayBtn = {
      type: buttonTypes.confirmBtn,
      label: this.dialogData.update,
      customclass: 'okay-btn'
    };

    this.cancelBtn = {
      type: buttonTypes.cancelBtn,
      label: this.dialogData.cancel,
      customclass: 'cancel-btn'
    };
    switch (this.dialogData.from) {
      case ComponentTypes.AuthRefundPopup:
        this.okayBtn.disbaledproperity = true;
        break;
    }
  }

  ngOnDestroy() {
    if (this.actionSubscription) { this.actionSubscription.unsubscribe(); }
  }

  action(eve){
    this.ps.actionEnabled$.next(this.dialogData.from);
    this.dialogRef.close({ok: true, cancel: false});
  }

  ngAfterViewInit(){
    this.actionSubscription =  this.ps.actiondisabled$.subscribe(value => {
      this.okayBtn.disbaledproperity = !value;
    });
    this.componentName1 = this.dialogData.componentDetails.componentName;
    this.dialogTitle = this.dialogData.componentDetails.popupTitle ? this.dialogData.componentDetails.popupTitle : '';
    const _componentRef = this.dynamicComponent.createComponent(this.componentName1);
    (_componentRef.instance as DynamicComponenReference).data = this.dialogData.componentDetails.popupInput;
  }

  closeDialog(event){
    this.ps.cancelEnabled$.next(this.dialogData.from);
    this.dialogRef.close({ok: false, cancel: event});
  }

}
